import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取账单信息*/
export function GetBillingmanage(data = {}){
return instance.request({
        method: "get",
        url: "billingmanage/billingmanage/",
        params:data
    })
}

/*获取账单编辑信息*/
export function BillingmanageEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "billingmanage/billingmanageedit/",
        params:data
    })
}

/*账单编辑*/
export function BillingmanageEdit(data = {}){
    let params = new URLSearchParams();
    params.append('billingmanageid',data.billingmanageid);
    params.append('weightfee',data.weightfee);
    params.append('unitprice',data.unitprice);
    params.append('notes',data.notes);
    params.append('copyfee',data.copyfee);
    params.append('stonefee',data.stonefee);
    params.append('goldprice',data.goldprice);
    params.append('silverprice',data.silverprice);
    params.append('fixedpricetag',data.fixedpricetag);
    params.append('fixedprice',data.fixedprice);
    params.append('laborcosts',data.laborcosts);
    params.append('samplefee',data.samplefee);
    params.append('checktag',data.checktag);
    params.append('update_price',data.update_price);
    params.append('updatepricetag',data.updatepricetag);
return instance.request({
        method: "post",
        url: "billingmanage/billingmanageedit/",
        data:params
    })
}

/*账单回退*/
export function BillingmanageRollback(data = {}){
    let params = new URLSearchParams();
    params.append('billingmanageid',data.editid);
    params.append('quantity',data.quantity);
    params.append('ordernumberData',data.ordernumberData);
    params.append('deliverydate',data.deliverydate);
return instance.request({
        method: "post",
        url: "billingmanage/billingmanagerollback/",
        data:params
    })
}

/*导出发货对账信息*/
export function ExportBillingmanage(data = {}){
return instance.request({
        method: "post",
        url: "billingmanage/billingmanageexport/",
        data:data,
        responseType: 'blob',
        timeout:360000
    })
}

/*导出金货发货对账信息*/
export function ExportBillingmanageGold(data = {}){
return instance.request({
        method: "post",
        url: "billingmanage/billingmanageGoldexport/",
        data:data,
        responseType: 'blob',
        timeout:360000
    })
}

/*导出真钻成本信息*/
export function ExportBillingmanageDiamonds(data = {}){
return instance.request({
        method: "post",
        url: "billingmanage/billingmanageDiamondsexport/",
        data:data,
        responseType: 'blob',
        timeout:360000
    })
}

/*确认账单*/
export function ConfirmBill(data = {}){
return instance.request({
        method: "post",
        url: "billingmanage/confirmbill/",
        data:data,
    })
}

/*获取账单类型*/
export function GetOrdercategory(data = {}){
return instance.request({
        method: "get",
        url: "billingmanage/getordercategory/",
        params:data
    })
}
